import React from 'react';
import Panel from '../components/Panel';
import './DiscussionView.scss';
import TimeAgo from 'timeago-react';
import helpers from '../lib/helpers';
import store, {actions} from '../store';
import auth from '../lib/auth';
import _ from 'lodash';

export default class DiscussionView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      initializing: true,
      data: {},
      comment: '',
    };

    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.addComment = this.addComment.bind(this);
    this.hasControl = this.hasControl.bind(this);
  }

  async componentDidMount() {
    let discussionId = this.props.match.params.discussionId;

    let [user, discussion, users] = await Promise.all([
      auth.user(),
      store.dispatch(actions.discussions.fetch(discussionId)),
      store.dispatch(actions.users.fetchAll()),
    ]);

    discussion.items = _.sortBy(discussion.items || [],['createdAt']);

    this.user = user;
    this.users = _.reduce(users, (container, user) => {
      container[user.userId] = user;
      return container;
    }, {});

    console.log(discussion);

    this.setState({
      initializing: false,
      user,
      data: discussion,
      users,
    });

  }

  addComment() {
    this.setState({
      submitting: true,
    });

    store.dispatch(actions.discussions.addComment(
        this.state.data.discussionId, this.state.comment,
    )).
        then((result) => {
          let items = (this.state.data.items || []);
          items.push(result);
          this.setState({
            submitting: false,
            comment: '',
            data: Object.assign({}, this.state.data,{
              items
            })
          });
        }).
        catch(err => {
          alert(err.message);
          this.setState({
            submitting: false,
          });
        });
  }

  handleCommentChange(e) {
    this.setState({
      comment: e.target.value,
    });
  }

  renderComment(item) {
    let commenter = this.users[item.userId] || {};
    return (
        <div className="row align-items-center DiscussionView--comment"
             key={item.discussionItemId}>
          <div className="col-md-8">
            <ul className="comment-row">
              <li className="comment-profile">
                <img src={commenter.picture || '/img/profile.svg'}
                     alt={commenter.nickname || commenter.email}
                     height={48}
                     width={48}
                />
              </li>
              <li className="comment-popus">
                <div className="comment-header">
                  <span className="name">{commenter.nickname ||
                  commenter.email}&nbsp;</span>
                  <span className="stamp">commented <TimeAgo
                      datetime={new Date(item.createdAt)}/></span>
                </div>
                <div>{item.content}</div>
              </li>
            </ul>
          </div>
        </div>
    );
  }

  renderControls() {
    return (
        <button
            className="btn btn-default"
            onClick={() => {
              this.props.history.push(
                  `/discussions/${this.state.data.discussionId}/edit`);
            }}
        >Edit Discussion</button>
    );
  }

  hasControl(){
    return this.state.data.userId === this.user.id || this.user.isAdmin;
  }

  render() {
    return this.state.initializing ? helpers.showPanelLoading() : (
        <Panel title="View Discussions"
               className="DiscussionView"
               controls={this.hasControl() ? this.renderControls() : null}
        >
          <div className="row DiscussionView--details align-items-center">
            <div className="col-md-8">
              <h2 className="title">{this.state.data.name}</h2>
              <div>
                {this.state.data.subject}
              </div>
            </div>
            {/*<div className="col-md-3 offset-md-1 text-center">*/}
            {/*<button className="btn btn-outline-secondary">Read More</button>*/}
            {/*</div>*/}
          </div>
          {
            this.state.data.items ?
                (<div className="DiscussionView--comments" id="comments">
                  {
                    (this.state.data.items || []).map((item) => {

                      return this.renderComment(item);
                    })
                  }
                </div>) :
                null
          }
          <div
              className="DiscussionView--add-comment clearfix">
            <div className="col-md-8 align-items-center d-flex pull-left">
              <div><img src={this.user.picture} className="avatar" height={48} width={48}/>
              </div>
              <textarea placeholder="Write a comment ..."
                        disabled={this.state.submitting}
                        value={this.state.comment}
                        onChange={this.handleCommentChange}
                        tabIndex={1}
              />
            </div>
            <div className="pull-right align-self-end">
              <button className="btn btn-send"
                      disabled={this.state.submitting}
                      tabIndex={2}
                      onClick={this.addComment}>
                <img src="/img/sendbtn.svg" alt=""/>
              </button>
            </div>
          </div>
        </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/DiscussionView.js